module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "fm-title",
    attrs: {
      "id": "fm-2"
    }
  }, [_c('em', [_vm._v("Abbreviations")])]), _vm._v(" "), _c('table', [_c('tbody', [_c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("AGG")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Siebenthal, Heinrich von. "), _c('em', [_vm._v("Ancient Greek Grammar for the Study of the New Testament")]), _vm._v(". Oxford: Lang, 2019")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("BDAG")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Danker, Frederick W., Walter Bauer, William F. Arndt, and F. Wilbur Gingrich. "), _c('em', [_vm._v("Greek-English Lexicon of the New Testament and Other Early Christian Literature")]), _vm._v(". 3rd ed. Chicago: University of Chicago Press, 2000. (Numbers refer to the entries of the digital version of BibleWorks.)")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("BDF")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Blass, Friedrich, Albert Debrunner, and Robert W. Funk. "), _c('em', [_vm._v("A Greek Grammar of the New Testament and Other Early Christian Literature")]), _vm._v(". Chicago: University of Chicago Press, 1961")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("BECNT")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Baker Exegetical Commentary on the New Testament")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("BGU")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Aegyptische Urkunden aus den Königlichen Staatlichen Museen zu Berlin, Griechische Urkunden")]), _vm._v(". 15 vols. Berlin: Weidmann, 1895–1937")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("BNTC")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Black’s New Testament Commentaries")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("BTS")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Biblical Tools and Studies")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("BZNW")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Beihefte zur Zeitschrift für die neutestamentliche Wissenschaft")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("CEV")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Contemporary English Version")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("CGCG")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Emde Boas, Evert van, Albert Rijksbaron, Luuk Huitink, and Mathieu de Bakker. "), _c('em', [_vm._v("The Cambridge Grammar of Classical Greek")]), _vm._v(". Cambridge: Cambridge University Press, 2019")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Duden")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Duden, die Grammatik: Unentbehrlich")]), _vm._v(" "), _c('em', [_vm._v("für")]), _vm._v(" "), _c('em', [_vm._v("richtiges Deutsch")]), _vm._v(". Edited by Angelika Wöllstein with Kathrin Kunkel-Razum, Franziska Münzberg, and Saskia Ripp. 9th ed. Berlin: Dudenverlag, 2016")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("EC")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Early Christianity")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("EKKNT")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Evangelisch-katholischer Kommentar zum Neuen Testament")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("FRLANT")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Forschungen zur Religion und Literatur des Alten und Neuen Testaments")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("GGNT")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Siebenthal, Heinrich von. "), _c('em', [_vm._v("Griechische Grammatik zum Neuen Testament: Neubearbeitung und Erweiterung der Grammatik Hoffmann / von Siebenthal")]), _vm._v(". Gießen: Brunnen, 2011")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("HThKNT")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Herders Theologischer Kommentar zum Neuen Testament")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("JSNTSup")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Journal for the Study of the New Testament Supplement Series")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("JTS")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Journal of Theological Studies")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("KJV")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("King James Version")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("L&N")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Louw, Johannes P., and Eugene A. Nida, eds. "), _c('em', [_vm._v("Greek-English Lexicon of the New Testament: Based on Semantic Domains")]), _vm._v(". 2nd ed. New York: United Bible Societies, 1989")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("LNTS")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("The Library of New Testament Studies")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("LSJ")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Liddell, Henry G., and Robert Scott. "), _c('em', [_vm._v("A Greek-English Lexicon.")]), _vm._v(" Revised and supplemented by H. S. Jones with the help of von R. McKenzie. 9th rev. ed. Oxford: Clarendon, 1996. (Numbers refer to the entries of the online version: "), _c('a', {
    attrs: {
      "href": "http://stephanus.tlg.uci.edu/lsj",
      "target": "_blank"
    }
  }, [_vm._v("http://stephanus.tlg.uci.edu/lsj/")]), _vm._v(".)")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Menge")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Bibelübersetzung Hermann Menge")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("MSG")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("The Message")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("NA"), _c('sup', [_vm._v("28")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Novum Testamentum Graece")]), _vm._v(", Nestle-Aland, 28th ed.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Neot")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Neotestamentica")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("NET")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("New English Translation")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("NGÜ")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Neue Genfer Übersetzung")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("NICNT")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("New International Commentary on the New Testament")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("NIV")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("New International Version")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("NPNF"), _c('sup', [_vm._v("1")])])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("The Nicene and Post-Nicene Fathers")]), _vm._v(", Series 1. Edited by Philip Schaff. 1886–1889. 14 vols. Repr., Peabody, MA: Hendrickson, 1994")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("NTOA")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Novum Testamentum et Orbis Antiquus")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("NTS")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("New Testament Studies")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("SBLDS")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Society of Biblical Literature Dissertation Series")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("SBS")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Stuttgarter Bibelstudien")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("SCS")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Septuagint and Cognate Studies")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("SJT")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Scottish Journal of Theology")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("SUNT")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Studien zur Umwelt des Neuen Testaments")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("TGV")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Today’s Greek Version")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("TWNT")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Theologisches Wörterbuch zum Neuen Testament")]), _vm._v(". Edited by Gerhard Kittel and Gerhard Friedrich. Stuttgart, 1932–1979")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("VF")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Verkündigung und Forschung")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("WUNT")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Wissenschaftliche Untersuchungen zum Neuen Testament")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a6b32438","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/007_Abbrevation.vue
// module id = 75
// module chunks = 0